module.exports = __webpack_public_path__ + "img/mark.3f75e257.jpg";